import axios from 'axios';
import type { AxiosResponse } from 'axios';
import { HOME_BANNERS_SERVICE_URL } from '../home-banners/constants';
import { PublishedHomeBannerListResponse } from './types';

export const getPublishedHomeBanners = (
    language: string
): Promise<AxiosResponse<PublishedHomeBannerListResponse>> =>
    axios.get(HOME_BANNERS_SERVICE_URL, {
        params: {
            published: true,
            language,
        },
    });
